
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke165aRequest, Sgke165aResponse, Sgke165aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke165aService {

  /**
   * コンストラクタ
   * @param {Sgke165aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke165aService
   */
  constructor(
    public service: Sgke165aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE165A_入金締め承認API呼び出し
   * @param {Sgke165aRequest} request 
   * @returns {Observable<Sgke165aResponse>}
   * @memberof UsedSgke165aService
   */
  public doSgke165a(request: Sgke165aRequest): Observable<Sgke165aResponse> {
    return this.service.sgke165aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE165A');
          return throwError(err.message);
        })
      );
  }

}
